export default "__VITE_ASSET__39920297__"